import { getProductsInShoppingCart } from 'reducers/ShoppingCart';
import { getVatRates } from 'reducers/vatRatesDB';
import { createConfirmation } from 'actions/Confirmation';

export function getCartHasOnlyTheseRates(expectedCodes: string[]) {
  return function validate(state) {
    const products = getProductsInShoppingCart(state);

    const badTaxProducts = products.filter(p => {
      const vatRate = getVatRates(state).find(
        v => String(v.id) === String(p.vatrateID),
      );
      if (!vatRate) {
        console.warn('Vatrate not found', p, vatRate, getVatRates(state));
        return false;
      }
      return !expectedCodes.includes(vatRate.code);
    });
    return badTaxProducts.length === 0;
  };
}
export function showTaxRateErrorPopup(expectedCodes: string[]) {
  const codeStr = expectedCodes.join(',');
  return async function showErrorPopup(dispatch) {
    return new Promise(resolve =>
      dispatch(
        createConfirmation(resolve, null, {
          title: 'Invalid vat rates in cart',
          body: `Some products in the cart have vat rates which have not been correctly configured. (the ones marked in red)
    
    For a vat rate to be usable, it needs to be assigned an EFSTA code (${codeStr}) ("Code used in accounting software" in back-office).
    For an overview of the vat rates on your account and how they are configured, see the table in the EFSTA plugin configuration.
    
    To resolve the issue, either:
    1) Remove the invalid products from the cart and replace them with different ones
    2) Fix the vat rate in the back office and refresh the POS
    `,
        }),
      ),
    );
  };
}

/**
 * Ensures that all items in the cart have a tax rate that matches one of the given codes.
 * If any item does not, then it shows a popup to the user describing the issue and throws an error
 */
export function assertCartSatisfiesTaxRates(expectedCodes: string[]) {
  return async function validateTaxRates(dispatch, getState) {
    if (!getCartHasOnlyTheseRates(expectedCodes)(getState())) {
      dispatch(showTaxRateErrorPopup(expectedCodes));
      throw new Error('Some products in cart have incompatible vat rates.');
    }
  };
}
